const catalogLinkSelector = 'a[href$="/collections/all"], a[href$="/collections/all/"]';

function getLocalizedCatalogUrl() {
  const marketPrefix = window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i)?.[0] || '';
  return `${marketPrefix}/collections/all`;
}

function normalizeCatalogLinks(root = document) {
  const catalogUrl = getLocalizedCatalogUrl();

  root.querySelectorAll(catalogLinkSelector).forEach((link) => {
    let url;

    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch {
      return;
    }

    const catalogPath = url.pathname.replace(/\/$/, '');

    if (catalogPath !== '/collections/all') return;

    link.setAttribute('href', catalogUrl);
  });
}

normalizeCatalogLinks();

document.addEventListener('DOMContentLoaded', () => {
  normalizeCatalogLinks();
});

window.addEventListener('load', () => {
  normalizeCatalogLinks();
});

document.addEventListener('shopify:section:load', (event) => {
  normalizeCatalogLinks(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  normalizeCatalogLinks(event.target);
});
